import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { LightbulbOutlineIcon, ExclamationTriangleSolidIcon, InformationCircleSolidIcon } from '@compono/ui-icons';
import { CoachTipBase } from './CoachTipBase/index.js';
import { CoachTipContent } from './CoachTipContent/index.js';

var iconMap = {
    success: LightbulbOutlineIcon,
    warning: ExclamationTriangleSolidIcon,
    critical: ExclamationTriangleSolidIcon,
    information: InformationCircleSolidIcon,
};
var CoachTip = function (_a) {
    var _b = _a.look, look = _b === void 0 ? "success" : _b, children = _a.children, _c = _a.title, title = _c === void 0 ? "" : _c, props = __rest(_a, ["look", "children", "title"]);
    return (jsx(CoachTipBase, __assign({ look: look, icon: (look && iconMap[look]) || LightbulbOutlineIcon }, props, { children: jsx(CoachTipContent, __assign({ title: title }, { children: children })) })));
};
CoachTip.displayName = "CoachTip";

export { CoachTip };
//# sourceMappingURL=CoachTip.js.map
